module.exports = __webpack_public_path__ + "static/media/icon_invert.04cb37ff.svg";